module.exports = __webpack_public_path__ + "img/tuandui.86120ef8.png";